<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY <br/>ELENA FERRANTE</span></h1>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372006/the-days-of-abandonment" target="_blank">The Days of Abandonment</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372426/the-lost-daughter" target="_blank">The Lost Daughter</a></em></p>
<p class="center"><em class="italic"> </em></p>
<p class="center">M<span class="smallcaps">Y </span>B<span class="smallcaps">RILLIANT </span>F<span class="smallcaps">RIEND</span></p>
<p class="center"><span class="smallcaps">(</span>The Neapolitan Quartet<span class="smallcaps">)</span></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609450786/my-brilliant-friend" target="_blank">My Brilliant Friend</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451349/the-story-of-a-new-name" target="_blank">The Story of a New Name</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452339/those-who-leave-and-those-who-stay" target="_blank">Those Who Leave and Those Who Stay</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452865/the-story-of-the-lost-child" target="_blank">The Story of the Lost Child</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609453701/the-beach-at-night" target="_blank">The Beach at Night</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452926/frantumaglia" target="_blank">Frantumaglia: A Writer's Journey</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609455583/incidental-inventions" target="_blank">Incidental Inventions</a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?040eee6d